export default "__VITE_ASSET__CXS93ofm__"